/* Krudo product-card note expand/collapse.

   The price/weight disclaimer on the simple product card is clamped to 3
   lines on mobile (component-card-product-simple.css). Tapping the note —
   or its "Read more" affordance — toggles the full text. Delegated on
   document so it keeps working after collection filtering re-renders the
   grid. No-op on desktop, where the mobile note is display:none. */
(function () {
  if (window.KrudoNoteToggle) return;
  window.KrudoNoteToggle = true;

  function toggle(note) {
    var expanded = note.classList.toggle('is-expanded');
    note.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var note = e.target.closest && e.target.closest('[data-note-expandable]');
    if (!note) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(note);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var note = e.target.closest && e.target.closest('[data-note-expandable]');
    if (!note) return;
    e.preventDefault();
    toggle(note);
  });
})();
